import React, { useEffect, useState } from "react";
import { Box, Button, DataTable, Layer, Text } from "grommet";
import { observer } from "mobx-react";
import { useStore } from "../../../../../Hooks/useStore";
import { toJS } from "mobx";
import { Mixpanel } from "../../../../../util/Helper";
import closeActionSidebar from "../../../../../assets/close_small.svg";
import "./RightSidebar.css";
import PopupPagination from "../../screens/IAM/Roles/PopupPagination";
import UsersPopupPagination from "../../screens/IAM/Users/UsersPopupPagination";

interface RightSidebarProps<T> {
  onCancel: () => void;
  title: string;
  description: string;
  tableTitle: string;
  tableData: T[];
  columns: any; // Adjust this based on your actual column type
  submitButtonTitle: string;
  onSubmit: (items: (string | number)[]) => void;
  showSubmitButton?: boolean;
  itemsNotSelectable?: boolean;
  selectionSizeRestriction?: number;
}

const RightSidebar = <T,>({
  onCancel,
  title,
  description,
  tableTitle,
  columns,
  tableData,
  submitButtonTitle,
  onSubmit,
  showSubmitButton,
  itemsNotSelectable,
  selectionSizeRestriction,
}: RightSidebarProps<T>) => {
  const { rootStore } = useStore();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
   
    console.log(toJS(rootStore.rightSidebarStore.getSelectedItems));
  }, [rootStore.rightSidebarStore.getSelectedItems]);

  const handleResetButtonClick = () => {
    rootStore.rightSidebarStore.setSelectedItems([]);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };


  const itemsPerPage = 7;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const visibleTableData = tableData.slice(startIndex, startIndex + itemsPerPage);


  return (
    <Layer
      style={{ borderRadius: "12px 0px 0px 0px", width: "700px" }}
      full="vertical"
      position="right"
      onEsc={() => {

        
 let uInfos = localStorage.getItem("userinfo");
 if(uInfos)
   {
    const userinformation = JSON.parse(uInfos);

        Mixpanel.track("web close " + submitButtonTitle,{name:userinformation.username});
   }
        onCancel();
      }}
    >
      <Box
        fill
        style={{
          minWidth: "378px",
          borderRadius: "12px 0px 0px 0px",
          maxWidth: "700px",
        }}
        flex
        flex-start
        direction="column"
        justify="between"
        align="center"
      >
        <Box
          style={{
            borderRadius: "12px 0px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          direction="column"
          as="header"
          background={"#E9F2FF"}
          width="100%"
          pad={"small"}
        >
          <Box>
            <Text
              style={{
                color: "#4B628A",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                display: "block",
              }}
            >
              {title}
            </Text>
            <Text style={{ fontSize: "12px" }}>**{description}**</Text>
          </Box>
          <Box style={{ textAlign: "center", justifyContent: "center" }}>
            <Button
              style={{
                color: "#357EFF",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "16px",
              }}
              onClick={() => {
                let uInfos = localStorage.getItem("userinfo");
                if (uInfos) {
                  const userinformation = JSON.parse(uInfos);
                  Mixpanel.track("web close " + submitButtonTitle,{ name: userinformation?.username });
                }
                onCancel();
              }}
            >
              <img src={closeActionSidebar} style={{ width: 20, height: 20 }} />
              Close
            </Button>
          </Box>
        </Box>
        <Box className="scroll-box-sidebar" fill flex direction="column" justify="start" align="center">
          <DataTable
            className="add-User-action-Table custom-data-table"
            style={{
              borderBottom: "none",
              width: "700px",
              color: "#41454B",
              fontFamily: "Inter",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "16px",
              padding: "12px 20px",

            //   overflowY: tableData ? "scroll" : "auto",
            // }}
            // columns={columns}
            // data={tableData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)}
            // step={itemsPerPage}
            // paginate={false}
              overflowY: rootStore.adminStore.getUserRightSidebarRoleSelection
                ? "scroll"
                : "auto", // Conditionally set overflowY
            }}
            columns={columns}
            data={visibleTableData}
            resizeable
            step={itemsPerPage}
            paginate={!rootStore.adminStore.getUserRightSidebarRoleSelection} // Conditionally enable/disable pagination
            {...(itemsNotSelectable
              ? {}
              : {
                  select: rootStore.rightSidebarStore.getSelectedItems,
                  onSelect: rootStore.rightSidebarStore.setSelectedItems,
                })}
          />

          <UsersPopupPagination
            currentPopupPage={currentPage}
            totalPopupPages={Math.ceil(tableData.length / itemsPerPage)}
            totalPopupItems={tableData.length} // Pass totalPopupItems
            onPageChange={handlePageChange}
          />
        </Box>
        <Box style={{ marginLeft: "auto" }} as="footer" pad="small" justify="end" direction="row" align="center">
          <Button
            style={{
              display: "flex",
              margin: "10px",
              padding: "14px 49px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "10px",
              border: "1px solid #357EFF",
              gap: "10px",
            }}
            color={"brand-1"}
            label="Reset"
            onClick={handleResetButtonClick}
          />
          {showSubmitButton !== undefined ? (
            <Button
              style={{
                display: "flex",
                padding: "14px 49px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "10px",
                border: "1px solid #357EFF",
              }}
              primary
              color={"brand-1"}
              label={submitButtonTitle}
              onClick={() => {
                let uInfos = localStorage.getItem("userinfo");
          if(uInfos)
            {
          const userinformation = JSON.parse(uInfos);
                Mixpanel.track("web " + submitButtonTitle + " clicked",{name:userinformation.username});
            }
                onSubmit(rootStore.rightSidebarStore.getSelectedItems);
              }}
            />
          ) : (
            <></>
          )}
        </Box>
      </Box>
    </Layer>
  );
};

export default observer(RightSidebar);
